/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as TabSwitcher } from "./TabSwitcher";
export type { TabSwitcherProps, TabSwitcherTab } from "./TabSwitcherProps";
